import colors from '../../../../../theme/foundations/colors'
import fonts from '../../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../../utills/pxToRem'
import sizes from '../../../../../theme/foundations/sizes'

export const addToCartButton = {
    fontWeight: 700,
    fontSize: pxToRem(14),
    textTransform: 'uppercase',
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    width: ['100%', '100%', pxToRem(295), pxToRem(295)],
    height: pxToRem(40),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxToRem(10),
    flexShrink: 0,
    border: 'none',
    cursor: 'pointer',
    boxSizing: 'border-box',
    [`@media (max-width: ${sizes.container.md})`]: {
        width: '100%',
        padding: `${pxToRem(14)} ${pxToRem(16)}`,
        fontSize: pxToRem(16),
        alignSelf: 'stretch',
        marginTop: pxToRem(12),
        flexShrink: 1,
        boxSizing: 'border-box'
    }
}
